const initValue = {
  merchantInfo: {
    theme: {},
  },
}

export default initValue
